// eslint-disable-next-line complexity
const serializeDentalOffice = form => ({
  info_id: form.infoId || null,
  dental_id: form.dentalId || null,
  period: form.period || null,
  siren: form.siren ? Number(form.siren) : null,
  management_software: (form.managementSoftware || []).join(',') || [],
  surface_sqm: form.surfaceSqm ? Number(form.surfaceSqm) : null,
  chair_count: form.chairCount ? Number(form.chairCount) : null,
  dentist_count: form.dentistCount ? Number(form.dentistCount) : null,
  collab_dentist_count: form.collabDentistCount ? Number(form.collabDentistCount) : null,
  chairside_assistant_count: form.chairsideAssistantCount ? Number(form.chairsideAssistantCount) : null,
  has_employed_prosthetist: form.hasEmployedProsthetist ?? false,
  has_radio_2d: form.hasRadio2d ?? false,
  has_radio_3d: form.hasRadio3d ?? false,
  has_sales_assistant: form.hasSalesAssistant ?? false,
  has_secretarial_assistant: form.hasSecretarialAssistant ?? false
});

export default serializeDentalOffice;
